parsePath